import React from "react";
import { Checkbox, Spinner } from "@ogt/ui";

interface TicketAgentsProps {
  enabled: boolean;
  onEnabledChange: (next: boolean) => void;
  onShowAll?: () => void;
  loading?: boolean;
}

export function TicketAgentsSection({
  enabled,
  onEnabledChange,
  onShowAll,
  loading = false,
}: TicketAgentsProps) {
  return (
    <Checkbox
      withLabel
      checked={enabled}
      id="ticket-agents-toggle"
      onCheckedChange={(v) => {
        const next = v === true;
        onEnabledChange(next);
        if (next) onShowAll?.();
      }}
      disabled={loading}
      className="min-h-4"
    >
      {loading ? (
        <span className="flex items-center h-4 gap-2">
          <Spinner className="w-4 h-4" />
          Laddar...
        </span>
      ) : enabled ? (
        "Dölj Försäljningsombud"
      ) : (
        "Visa Försäljningsombud"
      )}
    </Checkbox>
  );
}
